import { connect } from 'react-redux'
import ProviderProductPane from '../../components/products/ProviderProductPane'
import { IProviderProductFilters, IStoreState } from '../../types'
import { actionCreators } from '../../state/actions/provider-products'
import * as actions from '../../state/actions/global-settings'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const currentOrgId: string = state.organizations.currentOrgId as string
  return {
    showDeactivateProductModal: state.providerProduct.deactivateProductModal.show,
    showDeleteProductModal: state.providerProduct.deleteProductModal.show,
    showActivateProductModal: state.providerProduct.activateProductModal.show,
    routeProps: ownProps,
    OrgId: currentOrgId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchServiceLevels: () => {
      return dispatch(actions.fetchServiceLevels())
    },
    updateProductFilters: (params: IProviderProductFilters) => {
      return dispatch(actionCreators.updateProductFilters(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderProductPane)



// WEBPACK FOOTER //
// ./src/containers/products/ProviderProductPane.ts